import { ValueOf } from 'type-fest';

export const GRAIN_DIRECTION = {
  LW: 'LW', // lengthwise
  WW: 'WW', // widthwise
} as const;
export const COST_DIST_METHOD_SHEET = {
  AR: 'AR', // area of parts
  NU: 'NU', // number of parts
} as const;
export const COST_DIST_METHOD_LINEAR = {
  LE: 'LE', // length of parts
  NU: 'NU', // number of parts
} as const;
export const COSTING_UNIT_SHEET = {
  SH: 'SH', // per sheet
  LB: 'LB', // per POUND
} as const;
export const COSTING_UNIT_LINEAR = {
  PI: 'PI', // per piece
  IN: 'IN', // per inch
} as const;

export type GrainDirection = ValueOf<typeof GRAIN_DIRECTION>;
export type CostingUnitSheet = ValueOf<typeof COSTING_UNIT_SHEET>;
export type CostDistMethodSheet = ValueOf<typeof COST_DIST_METHOD_SHEET>;
export type CostingUnitLinear = ValueOf<typeof COSTING_UNIT_LINEAR>;
export type CostDistMethodLinear = ValueOf<typeof COST_DIST_METHOD_LINEAR>;
